import { type CSSProperties } from 'react';
import cx from 'classnames';

import { IconMessageSquare_16 } from 'src/assets/icons/16x16/IconMessageSquare_16';
import { IconThumbsDown_16 } from 'src/assets/icons/16x16/IconThumbsDown_16';
import { IconThumbsUp_16 } from 'src/assets/icons/16x16/IconThumbsUp_16';
import { type VoidFunction } from 'src/lib/types';

import styles from './ReviewBubble.module.scss';

interface ReviewBubbleProps {
  className?: string;
  style: CSSProperties;
  commentCount: number;
  thumbsUpCount: number;
  thumbsDownCount: number;
  active: boolean;
  onClick: VoidFunction;
}

export const ReviewBubble = ({
  className,
  style,
  commentCount,
  thumbsUpCount,
  thumbsDownCount,
  active,
  onClick,
}: ReviewBubbleProps) => {
  const counters = [
    { id: 'comments', count: commentCount, Icon: IconMessageSquare_16 },
    { id: 'thumbsUp', count: thumbsUpCount, Icon: IconThumbsUp_16 },
    { id: 'thumbsDown', count: thumbsDownCount, Icon: IconThumbsDown_16 },
  ].filter(({ count }) => count > 0);

  return (
    <button
      type="button"
      className={cx(styles.root, className, { [styles.active]: active })}
      style={style}
      onClick={onClick}
      data-testid="savedDocumentBubble"
    >
      {counters.map(({ id, count, Icon }) => (
        <span
          key={id}
          className={styles.counter}
          data-testid={`savedDocumentBubbleCount_${id}`}
        >
          <Icon className={styles.icon} />
          {count}
        </span>
      ))}
    </button>
  );
};
